import React, { useContext } from "react";
import { Grid } from "@material-ui/core";
import "../../CSS/Projects.css";
import ProjectBox from "./ProjectBox";

import p2p from "../../Assets/p2p.mp4";
import moc from "../../Assets/moc.png";
import alinma from "../../Assets/alinma.png";

import { AppContext } from "../Context.js";

const projectsArr = [
  {
    title: "Alinma Bank - KSA",
    image: alinma,
    descr:
      "KhalaQ ia a Linkedin alike project that has registration, login, job search, create post, group and more",
    techUsed: ["Anguar", "Springboot", "Kafka", "Event Sourcing", "K8S"],
    color: "#0089D6",
  },
  {
    title: "Ministry Of Culture - KSA - KhalaQ",
    image: moc,
    descr:
      "KhalaQ ia a Linkedin alike project that has registration, login, job search, create post, group and more",
    techUsed: ["Anguar", "Springboot", "Kafka", "Event Sourcing", "K8S"],
    color: "#0089D6",
  },
  {
    title: "Handling Loss of Peer in P2P Network",
    image: p2p,
    descr:
      "Handling the loss of peers in P2P by making an algorithm that finds another peer in the shortest time to continue its job. More details on Github",
    techUsed: ["Python", "Mininet", "Socket", "Threading"],
    github:
      "https://github.com/MohamedWSalah/P2P-Protocol-for-High-Critical-Mission-Network-and-handle-loss-of-Peer",
  },
];

export default function Projects({ id }) {
  const [itemSnapped] = useContext(AppContext);
  return (
    <React.Fragment>
      <div
        className={itemSnapped === "Projects" ? "vanish" : "projects"}
        id={id}
      >
        <Grid
          container
          spacing={3}
          direction="row"
          alignItems="center"
          justify="center"
        >
          <Grid item md={12} sm={12} xs={12}>
            <div className="titleDiv">
              <h1
                className="sectionsTitle"
                style={{ color: "#867ae9", paddingLeft: "15px" }}
              >
                Projects
              </h1>
            </div>
          </Grid>
          {projectsArr.map((project) => (
            <Grid item md={4} sm={6} xs={12} key={project.title}>
              <ProjectBox projectInfo={project} />
            </Grid>
          ))}
        </Grid>
      </div>
    </React.Fragment>
  );
}
